import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "Newsletter"
};
const _hoisted_2 = {
  class: "newsletter-content"
};
const _hoisted_3 = ["disabled"];
import { reactive, computed } from 'vue';
import newsletter from '@/composables/newsletter.js';
import { validateEmail } from '@/helpers';
export default {
  __name: 'Newsletter',
  setup(__props) {
    const form = reactive({
      email: '',
      fax: false
    });
    const state = reactive({
      loading: false
    });
    const canSubmit = computed(() => {
      return !state.loading && validateEmail(form.email);
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        model: form,
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => canSubmit.value && _unref(newsletter).handleSubmit(form, state, {}), ["prevent"]))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("h5", null, "Newsletter", -1)), _createVNode(_component_el_form_item, {
          class: "email-input"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "artist@email.com",
            modelValue: form.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.email = $event),
            disabled: state.loading,
            type: "email",
            onFocus: _unref(newsletter).handleEmailFieldFocusEvent
          }, null, 8, ["modelValue", "disabled", "onFocus"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "display": "none"
          },
          label: "Contact me by fax"
        }, {
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "fax",
            label: "Contact me by fax",
            disabled: state.loading,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.fax = $event)
          }, null, 8, _hoisted_3), [[_vModelCheckbox, form.fax]])]),
          _: 1
        })]), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          class: "extra-large transparent-base newsletter-button",
          onClick: _cache[2] || (_cache[2] = $event => _unref(newsletter).handleSubmit(form, state, {})),
          disabled: !canSubmit.value
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" Sign up ")])),
          _: 1
        }, 8, ["disabled"])])]),
        _: 1
      }, 8, ["model"]);
    };
  }
};